// import React from "react";
// import {
//   Button,
//   Divider,
//   InfoTimeCardAdv,
//   NewTable,
//   PageHeader,
//   PageTitle,
// } from "../../../../../../components";
// import { mapTableRows } from "../../../../../../utils";

// const WorkAuthorization = () => {
//   const tableData = [];
//   const columns = [
//     {
//       key: "jobTitle",
//       label: "Job Title",
//     },
//   ];

//   const mappedRows = mapTableRows(tableData, columns);
//   return (
//     <div>
//       <div className="flex gap-8 mb-6 ">
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Offboarding ID"
//             value="EX2022-20"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Date of Release"
//             value="11/11/2021"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Notice Due"
//             value="10/11/2021"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Exit Type"
//             value="Resignation"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Status"
//             value="Released"
//             prefix=""
//             suffix=""
//             align={"center"}
//             color="info"
//             size="xs"
//           />
//         </div>
//       </div>
//       <div>
//         <PageHeader
//           Section={
//             <div className="flex">
//               <PageTitle title={"H-1B"} icon={"id_card"} tag="p" />
//             </div>
//           }
//           RightSection={
//             <div>
//               <Button title="Send Notification" size="sm" />
//             </div>
//           }
//         />
//         <Divider />
//       </div>
//       <div className="mt-2">
//         <NewTable rows={mappedRows} columns={columns} hideToolBar />
//       </div>
//     </div>
//   );
// };

// export default WorkAuthorization;
import React from "react";
import {
  Button,
  Divider,
  InfoTimeCardAdv,
  NewTable,
  PageHeader,
  PageTitle,
} from "../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../utils";

const WorkAuthorization = () => {
  const tableData = [
    {
      h1bType: "Extension",
      filedOn: "--",
      receiptNumber: "LIN1903950621",
      status: "Expired",
      expiryDate: "2021-12-31T00:00:00.000Z",
      documents: "0",
    },
  ];
  const columns = [
    {
      key: "h1bType",
      label: "H-1B Type",
    },

    {
      key: "filedOn",
      label: "Filed On",
    },
    {
      key: "receiptNumber",
      label: "Receipt Number",
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) => dateFormator(row.expiryDate, "month-day-year"),
    },
    {
      key: "documents",
      label: "Documents",
      render: (row) => <div className="text-info">{row.documents}</div>,
    },
  ];

  const greenCardtableData = [
    {
      employeeType: "Employee",
      status: "I-140 Approved",
      appliedOn: "2020-12-07T00:00:00.000Z",
      comments: "Expired",
      documents: "2",
    },
  ];
  const greenCardcolumns = [
    {
      key: "employeeType",
      label: "Employee Type",
    },

    {
      key: "status",
      label: "Status",
    },
    {
      key: "appliedOn",
      label: "Applied On",
      render: (row) => dateFormator(row.appliedOn, "month-day-year"),
    },
    {
      key: "comments",
      label: "Comments",
    },

    {
      key: "documents",
      label: "Documents",
      render: (row) => (
        <div className="text-info">{row.documents} doucments</div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  const greenCardRows = mapTableRows(greenCardtableData, greenCardcolumns);

  return (
    <div>
      <div className="flex gap-8 mb-6 ">
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Offboarding ID"
            value="EX2022-20"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Date of Release"
            value="11/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Notice Due"
            value="10/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Exit Type"
            value="Resignation"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Status"
            value="Released"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
      </div>
      <div className="mb-[2px]">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"H-1B"} icon={"id_card"} tag="p" />
            </div>
          }
          RightSection={
            <>
              <Button title="Send Notification" size="sm" />
            </>
          }
        />
      </div>

      <Divider />
      <div className="mt-3">
        <NewTable
          rows={mappedRows}
          columns={columns}
          hideToolBar
          showCheckbox
        />
      </div>
      <div className="mt-6 mb-[2px]">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"GREEN CARD "} icon={"id_card"} tag="p" />
            </div>
          }
          RightSection={
            <>
              <Button title="Send Notification" size="sm" />
            </>
          }
        />
      </div>

      <Divider />
      <div className="mt-6">
        <NewTable rows={greenCardRows} columns={greenCardcolumns} hideToolBar />
      </div>

      <p className="body-two mt-6">
        Last updated on 01/12/2022 at 17:41:13 by Richa Sarkar.{" "}
        <span className="text-info cursor-pointer">View All Activities</span>
      </p>
    </div>
  );
};

export default WorkAuthorization;
